export const numberValidation = (
  name,
  message,
  required = true,
  max1,
  maxMessage1,
  max2,
  maxMessage2
) => [
  {
    required,
    message: message || `Please enter a ${name}`,
  },
  {
    validator: (_, value) => {
      if (value !== undefined && value !== null && value !== "") {
        if (!/^\d+$/.test(value)) {
          return Promise.reject("Only numeric values are allowed");
        }

        const num = parseInt(value, 10);

        if (num <= 0) {
          return Promise.reject("Value must be greater than zero");
        }

        if (max1 !== undefined && num > max1) {
          return Promise.reject(
            maxMessage1 || "Value must be less than total quantity"
          );
        }
        if (max2 !== undefined && num > max2) {
          return Promise.reject(
            maxMessage2 || "Value must be less than total quantity"
          );
        }
      }
      return Promise.resolve();
    },
  },
];

const SCRIPT_QUERY_REGEX = /<[^>]*>|script|javascript:|select|insert|update|delete|drop|union|truncate|--|;/i;

export const nameValidation = (nameLabel = "Name", required = true, maxLen = 20) => [
  {
    required,
    message: `${nameLabel} is required`,
  },
  {
    max: maxLen,
    message: `${nameLabel} cannot exceed ${maxLen} characters`,
  },
  {
    validator: (_, value) => {
      if (value !== undefined && value !== null && value !== "") {
        const trimmed = value.trim();
        if (required && !trimmed) {
          return Promise.reject(`${nameLabel} is required`);
        }
        if (value.length > maxLen) {
          return Promise.reject(`${nameLabel} cannot exceed ${maxLen} characters`);
        }
        if (SCRIPT_QUERY_REGEX.test(value)) {
          return Promise.reject("Invalid characters or script detected");
        }
        if (/\d/.test(value)) {
          return Promise.reject("Numeric values are not allowed in name");
        }
        if (!/^[a-zA-Z\s_-]+$/.test(value)) {
          return Promise.reject("Only letters, spaces, - and _ are allowed");
        }
      }
      return Promise.resolve();
    },
  },
];

export const emailValidation = (required = true) => [
  {
    required,
    message: "Email is required",
  },
  {
    validator: (_, value) => {
      if (value !== undefined && value !== null && value !== "") {
        const trimmed = value.trim();
        if (required && !trimmed) {
          return Promise.reject("Email is required");
        }
        if (SCRIPT_QUERY_REGEX.test(value)) {
          return Promise.reject("Invalid characters or script detected");
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(trimmed)) {
          return Promise.reject("Please enter a valid email address");
        }
      }
      return Promise.resolve();
    },
  },
];

export const discountCodeValidation = (required = true) => [
  {
    required,
    message: "Coupon code is required",
  },
  {
    max: 30,
    message: "Coupon code cannot exceed 30 characters",
  },
  {
    validator: (_, value) => {
      if (value !== undefined && value !== null && value !== "") {
        const trimmed = value.trim();
        if (required && !trimmed) {
          return Promise.reject("Coupon code is required");
        }
        if (trimmed.length > 30) {
          return Promise.reject("Coupon code cannot exceed 30 characters");
        }
        if (SCRIPT_QUERY_REGEX.test(value)) {
          return Promise.reject("Invalid characters or script detected");
        }
        if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
          return Promise.reject("Only alphanumeric characters, -, and _ are allowed");
        }
      }
      return Promise.resolve();
    },
  },
];

export const sanitizeSearchInput = (value) => {
  if (!value) return "";
  return value
    .replace(/<[^>]*>/gi, "")
    .replace(/script/gi, "")
    .replace(/javascript:/gi, "")
    .replace(/['";\\`<>]/g, "");
};

export const scriptQueryValidation = (fieldLabel = "Field") => [
  {
    validator: (_, value) => {
      if (value !== undefined && value !== null && value !== "") {
        if (SCRIPT_QUERY_REGEX.test(value)) {
          return Promise.reject(`${fieldLabel} contains invalid characters or script`);
        }
      }
      return Promise.resolve();
    },
  },
];


